import React from 'react'

import Navbar from '../components/Navbar';
import HistoryContent from '../components/HisotryContent';
import Footer from '../components/Footer'


const History = () => {
    return (
        <>
            <Navbar />
            <HistoryContent />
            <Footer />
        </>
    );
}

export default History;